import { render } from "./edit.vue?vue&type=template&id=a4fdd184"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=a4fdd184&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/building/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4fdd184"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4fdd184', __exports__)) {
    console.log('reload')
    api.reload('a4fdd184', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=a4fdd184", () => {
    console.log('re-render')
    api.rerender('a4fdd184', render)
  })

}


export default __exports__